import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class EmailVerifyComponent extends Vue {
  public onSubmit() {
    this.$router.push("/login");
  }
}
